import { useState } from "react";
import { Check } from "lucide-react";
import { Label } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { cn } from "@/lib/cn";
import { IconeColorido } from "@/components/comecar/selecao/IconeColorido";
import { iconeDaCategoria } from "@/components/comecar/selecao/icones-da-selecao";

/** Especialidades da clínica no diálogo de criar (opcional): os procedimentos delas entram na
 *  criação, sem passo de onboarding. Chips pequenos — os cartões grandes ficavam pesados aqui. */
export function EspecialidadesDaNovaClinica({ value, onChange }: { value: string[]; onChange: (ids: string[]) => void }) {
  const lista = trpc.specialty.list.useQuery().data ?? [];
  const [todas, setTodas] = useState(false);
  const visiveis = todas ? lista : lista.filter((e) => e.destaque || value.includes(e.id));
  const alternar = (id: string) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);

  return (
    <div className="space-y-2">
      <Label>
        Especialidades da clínica <span className="font-normal text-zinc-500 dark:text-muted-foreground">(opcional)</span>
      </Label>
      <p className="text-xs text-zinc-500 dark:text-muted-foreground">
        Os procedimentos delas já entram na clínica, sem preço. Dá para mudar depois em Configurações › Especialidades.
      </p>
      {/* Grade de botões iguais: os chips do tamanho de cada nome ficavam desalinhados. */}
      <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3">
        {visiveis.map((e) => {
          const marcada = value.includes(e.id);
          return (
            <button
              key={e.id}
              type="button"
              aria-pressed={marcada}
              onClick={() => alternar(e.id)}
              className={cn(
                "flex h-10 w-full min-w-0 items-center gap-2 rounded-md border px-1.5 text-left text-xs font-medium transition-colors",
                marcada
                  ? "border-emerald-500 bg-emerald-50 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-300"
                  : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300 dark:border-border dark:bg-card dark:text-foreground",
              )}
            >
              <IconeColorido {...iconeDaCategoria(e.label)} tamanho="sm" />
              <span className="min-w-0 flex-1 truncate" title={e.label}>{e.label}</span>
              {marcada && <Check className="h-3.5 w-3.5 shrink-0" strokeWidth={3} />}
            </button>
          );
        })}
      </div>
      {lista.some((e) => !e.destaque) && (
        <button type="button" onClick={() => setTodas(!todas)} className="text-xs font-semibold text-brand-700 hover:underline dark:text-primary">
          {todas ? "Mostrar só as principais" : "Ver todas as especialidades"}
        </button>
      )}
    </div>
  );
}
